import type { ContentEntry } from '@shared/model/embededContent.slice.ts';

// Calculates when the temporary content URL expires; null means it never expires
export const getExpiresAt = (contentMinutesDuration: number): number | null => {
    if (contentMinutesDuration === 0) return null;

    return Date.now() + contentMinutesDuration * 60 * 1000;
};

// Checks whether the cached content URL exists and has not expired
export const isContentEntryValid = (entry?: ContentEntry) => {
    if (!entry?.tempUrl) return false;

    return entry.expiresAt === null || Date.now() < entry.expiresAt;
};
